'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This allows you to work with object hierarchies to immutably modify
 * the structure. The portions of the structure that do not change will
 * === their previous values.
 *
 * Inspired by icepick.js
 */

function _cloneObj(obj) {
  var newObj = {};
  var keys = Object.keys(obj);
  var idx = keys.length;
  var key = void 0;
  while (idx--) {
    key = keys[idx];
    newObj[key] = obj[key];
  }
  return newObj;
}

function _sCloneObj(obj, filter, mapV) {
  var newObj = {};
  var keys = Object.keys(obj);
  var length = keys.length;
  var idx = length;
  var hasChanged = false;
  var key = void 0;
  while (idx--) {
    var i = length - idx - 1;
    key = keys[i];
    var v = obj[key];
    if (!filter || filter(v, key, i)) {
      var newV = mapV ? mapV(v, key, i) : v;
      newObj[key] = newV;
      hasChanged = hasChanged || newV !== v;
    } else hasChanged = true;
  }
  return hasChanged ? newObj : obj;
}

function _clone(coll) {
  if (Array.isArray(coll)) {
    return coll.slice();
  } else {
    return _cloneObj(coll);
  }
}

var ice = exports.ice = function ice(coll) {
  return ice.chain(coll);
};

function _simpleSet(coll, key, value) {
  if (coll[key] === value) {
    return coll;
  }
  var newObj = _clone(coll);
  newObj[key] = value;
  return newObj;
}

ice.set = ice.setIn = function (coll, pathableOrValue, value) {
  if (arguments.length === 2) {
    return pathableOrValue;
  }
  var path = ice.toPath(pathableOrValue);
  var key0 = path[0];
  if (path.length === 0) {
    return value;
  }
  if (path.length === 1) {
    return _simpleSet(coll, key0, value);
  } else {
    return _simpleSet(coll, key0, ice.set(coll[key0] || (typeof key0 === 'number' ? [] : {}), path.slice(1), value));
  }
};

function _simpleUnset(coll, key) {
  if (Array.isArray(coll)) {
    return ice.spliceIn(coll, [], key, 1);
  }
  var newObj = _clone(coll);
  delete newObj[key];
  return newObj;
}

ice.unset = ice.unsetIn = function (coll, pathable) {
  var path = ice.toPath(pathable);
  var key0 = path[0];
  if (coll === undefined) {
    return undefined;
  } else if (path.length === 0) {
    return undefined;
  } else if (path.length === 1) {
    return _simpleUnset(coll, key0);
  } else {
    return _simpleSet(coll, key0, ice.unset(coll[key0], path.slice(1)));
  }
};

ice.get = ice.getIn = function (coll, pathable) {
  return ice.toPath(pathable).reduce(function (curr, key) {
    if (!curr) {
      return;
    }
    return curr[key];
  }, coll);
};

ice.update = ice.updateIn = function (coll, pathableOrCallback, optCallback) {
  var emptyPath = arguments.length === 2;
  var callback = emptyPath ? pathableOrCallback : optCallback;
  var pathable = emptyPath ? [] : pathableOrCallback;
  var existingVal = ice.get(coll, pathable);
  return ice.set(coll, pathable, callback(existingVal));
};

function inPlaceFn(methodName, arr, args) {
  var newArr = arr.slice();
  newArr[methodName].apply(newArr, _toConsumableArray(args));
  return newArr;
}

function immutableFn(methodName, arr, args) {
  return arr[methodName].apply(arr, _toConsumableArray(args));
}

var objectFns = {
  'map': function map(obj, fn) {
    return _sCloneObj(obj, false, fn);
  },
  'filter': function filter(obj, fn) {
    return _sCloneObj(obj, fn, false);
  },
  'assign': function assign(val) {
    for (var _len = arguments.length, objs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      objs[_key - 1] = arguments[_key];
    }

    var noChange = objs.every(function (obj) {
      return Object.keys(obj).every(function (targetKey) {
        return val[targetKey] === obj[targetKey];
      });
    });
    return noChange ? val : Object.assign.apply(Object, [{}, val].concat(objs));
  }
};

var inPlaceFns = ['pop', 'shift', 'reverse', 'sort', 'splice', 'push', 'unshift'];
var immutableFns = ['slice', 'map', 'filter'];
var allDelegates = inPlaceFns.concat(immutableFns, 'assign');
allDelegates.forEach(function (methodName) {
  var caller = inPlaceFns.indexOf(methodName) >= 0 ? inPlaceFn : immutableFn;
  var objCaller = objectFns[methodName];
  ice[methodName + 'In'] = function (coll, pathable) {
    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    return ice.update(coll, pathable, function (val) {
      return val === undefined ? undefined : (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && !Array.isArray(val) ? objCaller.apply(undefined, [val].concat(args)) : caller(methodName, val, args);
    });
  };
  ice[methodName] = function (val) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    if (!Array.isArray(val) && (_typeof(args[0]) !== 'object' || Array.isArray(args[0])) && typeof args[0] !== 'function') {
      return ice[methodName + 'In'].apply(ice, [val].concat(args));
    } else {
      return ice[methodName + 'In'].apply(ice, [val, []].concat(args));
    }
  };
});

var chainProto = {
  value: function value() {
    return this._val;
  },
  on: function on(pathable, callback) {
    return ice.chain(ice.update(this._val, pathable, function (state) {
      return callback(ice(state)).value();
    }));
  }
};

Object.keys(ice).forEach(function (methodName) {
  var method = ice[methodName];
  chainProto[methodName] = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return ice.chain(method.apply(undefined, [this._val].concat(args)));
  };
});

ice.chain = function (coll) {
  var wrapped = Object.create(chainProto);
  wrapped._val = coll;
  return wrapped;
};

ice.toPath = function (s) {
  return s === undefined || s === null ? [] : [].concat(typeof s === 'string' ? s.split(/[\[.]/).map(function (k) {
    if (k.slice(-1) === ']') {
      var newK = k.slice(0, -1);
      var n = +newK;
      return isNaN(n) ? newK : n;
    } else {
      return k;
    }
  }) : s);
};



//////////////////
// WEBPACK FOOTER
// ./~/icepath/dist/icepath.js
// module id = 11
// module chunks = 4